import update from "immutability-helper";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import {
  commonMessages,
  GenesisTypes,
  isEmptyObject,
  notificationSetting,
  notificationType,
  notUndefined,
  OwlSlider,
  showNotification,
} from "../Common";
import { BabyMintingService } from "../Services";
import { GenesisComponent } from "./GenesisComponent";
import { GenesisListComponent } from "./GenesisListComponent";

export const DndElement = React.memo(
  React.forwardRef(
    (
      { currentDay, defaultPair, genesisData, handleGenesisSubmit, ...props },
      ref
    ) => {
      const [seperateGenesisList, setSeperateGenesisList] = useState([]);
      // const [activeParent, setActiveParent] = useState({});
      const [genesisContainer, setGenesisContainer] = useState();
      const [genesisInfo, setGenesisInfo] = useState({});
      const [droppedCard, setDroppedCard] = useState([]);
      const [stateUpdated, setStateUpdated] = useState(false);
      const [initialUpdate, setInitialUpdate] = useState(true);
      const [transactionDate, setTransactionDate] = useState();
      const genesisContainerRef = useRef();

      useEffect(() => {
        setGenesisInfo(genesisData);
      }, [genesisData]);

      useEffect(() => {
        if (!isEmptyObject(genesisInfo)) {
          setData(genesisInfo);
          getSeperateGenesis(filterReverseActive(genesisInfo));
          if (initialUpdate) {
            setTransactionDate(
              moment(genesisInfo?.can_baby_mint_on).format("DD/MM/YYYY")
            );
            setInitialUpdate(false);
          } else {
            let maxDate = Math.max(
              genesisInfo?.genesis[0].txdate,
              genesisInfo?.genesis[1].txdate
            );
            let convertedDate = moment.unix(maxDate).format("DD/MM/YYYY");
            let addedDaysDate = moment(convertedDate, "DD/MM/YYYY")
              .add(currentDay?.day, "days")
              .format("DD/MM/YYYY");
            setTransactionDate(addedDaysDate);
          }
        }
      }, [genesisInfo]);

      const isDroppedCard = (cardName) => {
        return droppedCard.indexOf(cardName) > -1;
      };

      const setData = (genesisInfo) => {
        setGenesisInfo(genesisInfo);
        setGenesisContainer(() => {
          let tempArray = [];
          genesisInfo?.genesis.map((element, idx) => {
            tempArray.push({
              accept: element?.genesisType,
              index: idx,
              lastDroppedItem: element,
            });
          });

          return tempArray;
        });

        // let filtered = filterActiveGenesisByType(
        //   genesisInfo?.genesis,
        //   genesisInfo?.active
        // );
        // setActiveParent((activeParent) => {
        //   return filtered;
        // });
      };
      // const handleDrop = useCallback(
      //   (index, item) => {
      //     const { name } = item;

      //     setDroppedCard(
      //       update(droppedCard, name ? { $push: [name] } : { $push: [] })
      //     );

      //     setGenesisContainer(
      //       update(genesisContainer, {
      //         [index]: { lastDroppedItem: { $set: item } },
      //       })
      //     );
      //   },
      //   [droppedCard, genesisContainer]
      // );

      const getSeperateGenesis = async (object) => {
        setSeperateGenesisList([]);
        BabyMintingService.getSeperateGenesis({
          wallet_address: genesisData?.wallet_address,
          gender: object?.genesisType,
          token_id: object?.token_id,
        }).then((response) => {
          if (response?.status === false) {
            showNotification(
              notificationType.DANGER,
              response.message,
              notificationSetting
            );
            getSeperateGenesis(filterReverseActive(genesisInfo));
          } else if (response?.status === true) {
            setSeperateGenesisList(() => {
              return response?.data;
            });
          }
        });
      };

      const updateGenesis = async (object) => {
        setSeperateGenesisList([]);
        BabyMintingService.updateGenesisPair({
          wallet_address: genesisInfo?.wallet_address,
          female_token_id: genesisInfo?.genesis[0].token_id,
          male_token_id: genesisInfo?.genesis[1].token_id,
        }).then((response) => {
          if (response?.status === false) {
            showNotification(
              notificationType.DANGER,
              response.message,
              notificationSetting
            );
          } else if (response?.status === true) {
            showNotification(
              notificationType.SUCCESS,
              response.message,
              notificationSetting
            );
            handleGenesisSubmit();
          }
        });
      };

      const filterActiveGenesisByType = (list, type) => {
        return list.filter(function (o) {
          return o.genesisType === type;
        })[0];
      };

      const filterReverseActive = (genesisInfo) => {
        let activeIndex = genesisInfo?.activeIndex;
        return genesisInfo?.genesis.filter(function (o) {
          return parseInt(o.genesisIndex) !== activeIndex;
        })[0];
      };

      const replaceGenesis = (lastDroppedItem) => {
        setGenesisInfo((genesisInfo) => {
          return {
            ...genesisInfo,
            activeIndex: lastDroppedItem.genesisIndex,
            active: lastDroppedItem.genesisType,
          };
        });
        setStateUpdated(false);
      };

      const handleInitialChange = (cardData) => {
        let tempData = genesisInfo;

        const toBeUpdated = {
          genesisType: cardData.gender,
          genesisIndex: genesisInfo.activeIndex,
          ...cardData,
        };

        tempData.genesis[genesisInfo.activeIndex] = toBeUpdated;
        // const newGenesis = tempData.genesis.map((obj) => {
        //   // if (obj.genesisType === cardData.gender) {
        //   if (obj.genesisType === tempData.active) {
        //     return toBeUpdated;
        //   }
        //   return obj;
        // });
        // tempData.genesis = newGenesis;

        setData(tempData);
        setStateUpdated(true);
        if (notUndefined(genesisContainerRef.current.scrollIntoView)) {
          genesisContainerRef.current.scrollIntoView();
        }
        // const newState = genesisContainer.map((obj) => {
        //   // 👇️ if id equals 2 replace object
        //   if (obj.accept === cardData.gender) {
        //     return {
        //       accept: cardData.gender,
        //       lastDroppedItem: toBeUpdated,
        //     };
        //   }
        //   // 👇️ otherwise return object as is
        //   return obj;
        // });
        // setGenesisContainer(newState);
      };

      const handleCardReplace = (cardData) => {
        let tempData = genesisInfo;

        const toBeUpdated = {
          genesisType: cardData.gender,
          genesisIndex: genesisInfo.activeIndex,
          ...cardData,
        };

        tempData.genesis[genesisInfo.activeIndex] = toBeUpdated;
        // const newGenesis = tempData.genesis.map((obj) => {
        //   // if (obj.genesisType === cardData.gender) {
        //   if (obj.genesisType === tempData.active) {
        //     return toBeUpdated;
        //   }
        //   return obj;
        // });
        // tempData.genesis = newGenesis;
        let maxDate = Math.max(
          tempData?.genesis[0].txdate,
          tempData?.genesis[1].txdate
        );
        let convertedDate = moment.unix(maxDate).format("DD/MM/YYYY");
        let addedDaysDate = moment(convertedDate, "DD/MM/YYYY")
          .add(currentDay?.day, "days")
          .format("DD/MM/YYYY");

        setData(tempData);
        setStateUpdated(true);
        setTransactionDate(addedDaysDate);
        if (notUndefined(genesisContainerRef.current.scrollIntoView)) {
          genesisContainerRef.current.scrollIntoView();
        }
        // const newState = genesisContainer.map((obj) => {
        //   // 👇️ if id equals 2 replace object
        //   if (obj.accept === cardData.gender) {
        //     return {
        //       accept: cardData.gender,
        //       lastDroppedItem: toBeUpdated,
        //     };
        //   }
        //   // 👇️ otherwise return object as is
        //   return obj;
        // });
        // setGenesisContainer(newState);
      };

      const handleUpdateGenesis = (event) => {
        event.preventDefault();
        if (
          parseInt(genesisInfo?.genesis[0].token_id) ===
            parseInt(defaultPair[0].token_id) &&
          parseInt(genesisInfo?.genesis[1].token_id) ===
            parseInt(defaultPair[1].token_id)
        ) {
          // showNotification(
          //   notificationType.DANGER,
          //   commonMessages.defaultPair,
          //   notificationSetting
          // );
          setStateUpdated(false);
        } else {
          Swal.fire({
            title: "Are you sure?",
            text: commonMessages.changePairConfirmation,
            // html: "<h6>All the filled details are correct!<br/>Once you lock the data, you won&apos;t be able to edit it again.</h6/>",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, Move Forward!",
            cancelButtonText: "No, let me check again!",
          }).then((result) => {
            if (result.isConfirmed) {
              updateGenesis();
            } else {
              // showNotification(
              //   notificationType.WARNING,
              //   commonMessages.userCancelled,
              //   notificationSetting
              // );
              // console.log("Cancelled");
            }
          });
        }
      };
      return (
        <>
          <p>
            Select which Female and Male you would like to pair together to
            manifest a divine Baby Creator.
          </p>
          <div className={"drag-drop-container"}>
            <h3>
              Select the Male & Female Tokens that you would like to pair
              together
            </h3>
            <div className={"genesis-container"} ref={genesisContainerRef}>
              {notUndefined(genesisContainer) &&
                genesisContainer.length > 0 &&
                genesisContainer.map(
                  ({ accept, index, lastDroppedItem }, idx) => (
                    <>
                      <GenesisComponent
                        {...{ accept, index, lastDroppedItem, genesisInfo }}
                        // onDrop={(item) => handleDrop(index, item)}
                        handleCardChange={(lastDroppedItem) =>
                          replaceGenesis(lastDroppedItem)
                        }
                        key={idx}
                      />
                    </>
                  )
                )}
            </div>
            <div className="babydate">
              <i className="bi bi-calendar4-week"></i> Date of Fuse 1st baby is:{" "}
              <span>{transactionDate}</span>
            </div>
            <h3>
              Replace the currently selected token by choosing one of the
              available tokens below
            </h3>
            {notUndefined(seperateGenesisList) &&
              seperateGenesisList.length > 0 && (
                <div className={"genesis-data-list"}>
                  <OwlSlider
                    {...{
                      nav: false,
                      dots: true,
                      margin: 20,
                      stagePadding: 0,
                      autoplay: false,
                      responsive: {
                        0: {
                          items: 2,
                        },
                        575: {
                          items: 3,
                        },
                        768: {
                          items: 4,
                        },
                        1280: {
                          items: 6,
                        },
                        1600: {
                          items: 7,
                        },
                      },
                    }}
                  >
                    {seperateGenesisList.map(
                      ({ gender, image, owner, token_id, txdate }, index) => (
                        <GenesisListComponent
                          {...{
                            gender,
                            image,
                            owner,
                            token_id,
                            txdate,
                          }}
                          isDroppedCard={isDroppedCard(token_id)}
                          activeToken={
                            genesisInfo.genesis[genesisInfo.activeIndex]
                              .token_id
                          }
                          genesisInfo={{ ...genesisInfo }}
                          handleCardChange={(cardData, index) =>
                            handleCardReplace(cardData)
                          }
                          handleInitialChange={(cardData) => {
                            handleInitialChange(cardData);
                          }}
                          key={index}
                        />
                      )
                    )}
                  </OwlSlider>
                </div>
              )}
          </div>
          <p className="terms">
            By clicking on the below button you agree with the updated date of
            fuse on the above-selected pair. You can now fuse 1st baby on{" "}
            <span>{transactionDate}</span>.
          </p>
          <div className="text-center">
            <button
              type="button"
              className="btn"
              onClick={handleUpdateGenesis}
              disabled={!stateUpdated}
            >
              Agreed & Update
            </button>
          </div>
        </>
      );
    }
  )
);

// export default DndElement;
